import React from "react";
import MiniTableContainer from "../../common/miniTable/MiniTableContainer";
import {GetAdminProjectDashInfoResponseData} from "../../../types/admin";
import {adminProjectInfoTableAPI} from "../../../services/admin";
import styles from "./AdminProjectInfoCard.module.css";

interface Column<T> {
    key: keyof T;
    header: string;
    width?: string;
    render?: (value: T) => React.ReactNode;
}
//컬럼
const projectColumns: Column<GetAdminProjectDashInfoResponseData>[] = [
    {
        key: 'companyName',
        header: '회사명',
        width: '25%'
    },
    {
        key: 'monthlyProjectsAverage',
        header: '월 프로젝트 수 평균',
        width: '25%',
        render: (row) => Number(row.monthlyProjectsAverage).toFixed(1)
    },
    {
        key: 'dataAverage',
        header: '데이터 수 평균',
        width: '25%',
        render: (row) => Number(row.dataAverage).toFixed(2)
    },
    {
        key: 'thisMonthProjects',
        header: '당월 프로젝트 수',
        width: '25%',
        render: (row) => row.thisMonthProjects.toLocaleString()
    }
];
//어드민 프로젝트 정보 카드
const AdminProjectInfoCard: React.FC = () => {
    //테이블 탭
    const tabs = [
        {
            id: 'projects',
            label: '프로젝트 현황',
            fetchData: async (page: number) => await adminProjectInfoTableAPI(page),
            columns: projectColumns,
        }
    ];

    return (
        // 미니 테이블
        <div className={styles.container}>
                {/*미니 테이블*/}
            <MiniTableContainer
                tabs={tabs}
                size="medium"
                itemsPerPage={3}/>
        </div>
    );
};

export default AdminProjectInfoCard;